import { Pipe, PipeTransform } from '@angular/core';
import { SharedCommonUtility } from '../../../shared/utils/common.utility';

@Pipe({
  name: 'compactNumber',
  standalone: false,
})
export class CompactNumberPipe implements PipeTransform {
  transform(value: number): string {
    return SharedCommonUtility.formatCompactNumber(value);
  }
}
